// iOS and web paint behind the status bar themselves; only Android needs the
// declaration to reach the frame's bands (StatusBar.android.js).
export { StatusBar, setStatusBarStyle } from "expo-status-bar"
